import PrescriptionInterface, {
  PrescriptionItemInterface,
  DoctorInterface,
  PatientInterface,
} from '../../interfaces/prescription';
import { PermissionsInterface } from '../../interfaces/drugstore';

export interface PrescriptionError {
  exists: boolean;
  status: number;
}
export interface PrescriptionState {
  readonly error: PrescriptionError;
  readonly loading: boolean;
  readonly prescription: PrescriptionInterface;
  readonly dispensation: {
    errors: string[];
    loading: boolean;
  };
  readonly permissions: PermissionsInterface;
  readonly mustUpdateHistory: boolean;
}

export enum ActionTypes {
  FETCH = 'prescription/FETCH',
  FETCH_SUCCESS = 'prescription/FETCH_SUCCESS',
  FETCH_ERROR = 'prescription/FETCH_ERROR',
  DISPENSE = 'prescription/DISPENSE',
  DISPENSE_SUCCESS = 'prescription/DISPENSE_SUCCESS',
  DISPENSE_ERROR = 'prescription/DISPENSE_ERROR',
  DISPENSE_CANCEL = 'prescription/DISPENSE_CANCEL',
  DISPENSE_CANCEL_SUCCESS = 'prescription/DISPENSE_CANCEL_SUCCESS',
  UPDATE_ITEMS = 'prescription/UPDATE_ITEMS',
  SET_UNLOCK_DATA = 'prescription/SET_UNLOCK_DATA',
}

export interface FetchAction {
  type: ActionTypes.FETCH;
}

export interface FetchSuccessAction {
  type: ActionTypes.FETCH_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface FetchErrorAction {
  type: ActionTypes.FETCH_ERROR;
  status: number;
}

export interface DispenseAction {
  type: ActionTypes.DISPENSE;
}

export interface DispenseSuccessAction {
  type: ActionTypes.DISPENSE_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface DispenseErrorAction {
  type: ActionTypes.DISPENSE_ERROR;
  errors: string[];
}

export interface DispenseCancelAction {
  type: ActionTypes.DISPENSE_CANCEL;
}

export interface DispenseCancelSuccessAction {
  type: ActionTypes.DISPENSE_CANCEL_SUCCESS;
  prescription: PrescriptionInterface;
}

export interface UpdateItemsAction {
  type: ActionTypes.UPDATE_ITEMS;
  items: PrescriptionItemInterface[];
}

export interface SetUnlockDataActionPayload {
  doctor: Partial<DoctorInterface>;
  patient: Partial<PatientInterface>;
}

export interface SetUnlockDataAction {
  type: ActionTypes.SET_UNLOCK_DATA;
  payload: SetUnlockDataActionPayload;
}

export type Action =
  | FetchAction
  | FetchSuccessAction
  | FetchErrorAction
  | DispenseAction
  | DispenseSuccessAction
  | DispenseErrorAction
  | DispenseCancelAction
  | DispenseCancelSuccessAction
  | UpdateItemsAction
  | SetUnlockDataAction;
